import axios from 'axios'

export default {
    namespaced: true,
    state: {
        transactions: [],
        headers: [],
        loading: false,
        url_search: '',
        url_sort: '',
        pagination: {
            page_count: 1,
            page: 1,
            per_page:30
        }
    },
    getters: {
        get_loading(state) {
            return state.loading;
        },
        get_headers(state) {
            return state.headers
        },
        get_transactions(state) {
            return state.transactions
        },
        get_pagination(state) {
            return state.pagination
        },
        get_url_search(state){
            return state.url_search
        },
        get_url_sort(state){
            return state.url_sort
        }
    },
    mutations: {
        set_loading(state, value) {
            state.loading = value
        },
        set_pagination(state, obj) {
            state.pagination.page = obj.current_page
            state.pagination.page_count = obj.last_page
            state.pagination.per_page = obj.per_page
        },
        set_headers(state, headers) {
            state.headers = headers
        },
        set_transactions(state, transactions) {
            state.transactions = transactions
        },
        set_url_sort(state, value){
            state.url_sort = value
        },
        set_url_search(state, value){
            state.url_search = value
        }

    },
    actions: {
        async fetch_ikom({commit, state}) {
            commit('set_loading', true)
            try {
                const response = await axios.get('/api/transport/ikom?page='
                    + state.pagination.page
                    + state.url_search
                    + state.url_sort)
                if (response.status === 200) {
                    commit('set_pagination', {
                        current_page: response.data.paginate.current_page,
                        last_page: response.data.paginate.last_page,
                        per_page: response.data.paginate.per_page
                    })
                    commit('set_transactions', response.data.transactions)
                    commit('set_headers', response.data.headers)
                }
            } catch (e) {

            } finally {
                commit('set_loading', false)
            }
        }
    }
}